/* eslint-disable max-len */
import React, { useEffect, useState, Suspense, lazy, useContext } from 'react';
import CardHeader from '../../../../components/CardHeader';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { dataService } from '../../../../services/data.services';
import { formatAdjustedDate, formatDateTime } from '../../../../CommonMethods/formatDate';
import moment from 'moment';
import GlobalContext from '../../../../components/Context/GloablContext';


const ItemsTable = lazy(() => import('./Components/ItemsTable'));
const GRNTable = lazy(() => import('./Components/GRNTable'));

const ViewPurchaseOrder = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(true)
    const [viewPODetails, setViewPODetails] = useState({})
    const [searchParams, setSearchParams] = useSearchParams('')
    const {setToastErrorMessage} = useContext(GlobalContext)
    const navigate = useNavigate('')

    const getViewPODetails = async () =>{
        try{
            let poNumber = encodeURIComponent(id)
            setLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `purchase-order/details?po_id=${poNumber}&branch_id=${branch_id}`
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data
            setViewPODetails(temp)
        } catch(error) {
            navigate('/404')
            console.log(error)
            setLoading(false)
        } finally{
            setLoading(false)
        }
    } 

    useEffect(()=>{
        getViewPODetails()
    }, [])

    return(
        <CardHeader noPadding >
            <TopBarWithShadow
                Tittle={'Purchase Order Details'} isback={true} backLocation={`/inventory-master/purchase-order?${searchParams.toString()}`}
            />
            {/* main body */}
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`} />}>
                {loading ? <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/> 
                    : <div className='mainDataCntnrPageDiv scrollBlue_thick'>
                        {/* po details */}
                        <div className='border border-[#D0D5DD] rounded p-3 mb-4 w-[65%] m-auto'>
                            <div className='-mx-2 flex w-full'>
                                <div className='w-[50%]  px-2 pr-3'>
                                    <div className='flex mb-4'>
                                        <a className='w-[130px]' id='po_amount_label'>PO Amount</a>
                                        <a className='font-semibold break-all' id='po_amount'>{Number(viewPODetails?.purchase_order_details?.po_amount).toFixed(2) || '0'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='w-[130px]' id='po_date_label'>PO Date</a>
                                        <a className='font-semibold break-all' id='po_date'>{formatAdjustedDate(viewPODetails?.purchase_order_details?.po_date) || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='w-[130px]' id='po_added_label'>PO Added Date</a>
                                        <a className='font-semibold break-all' id='po_date'>{formatDateTime(viewPODetails?.purchase_order_details?.created_at) || '-'}</a>
                                    </div>
                                    <div className='flex'>
                                        <a className='w-[130px]' id='fy_label'>FY</a>
                                        <a className='font-semibold break-all' id='fy'>{viewPODetails?.purchase_order_details?.financial_year || '-'}</a>
                                    </div>
                                </div>
                                <div className='w-[50%]  px-2 pl-3'>
                                    <div className='flex mb-4'>
                                        <a className='w-[120px]' id='po_number_label'>PO #</a>
                                        <a className='font-semibold break-all ' id='po_number'>{viewPODetails?.purchase_order_details?.po_number || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='w-[120px]' id='vendor_name_label'>Vendor Name</a>
                                        <a className='font-semibold break-all ' id='vendor_name'>{viewPODetails?.purchase_order_details?.vendor_name || '-'}</a>
                                    </div>
                                    <div className='flex mb-4'>
                                        <a className='w-[120px]' id='delivery_date_label'>Delivery Date</a>
                                        <a className='font-semibold break-all ' id='delivery_date'>{moment(viewPODetails?.purchase_order_details?.delivery_date).format('MMM DD, YYYY') || '-'}</a>
                                    </div>
                                    <div className='flex'>
                                        <a className='w-[120px]' id='description_label'>Description</a>
                                        <a className='font-semibold break-all ' id='description'>{viewPODetails?.purchase_order_details?.description || '-'}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* items list */}
                        {viewPODetails?.purchase_order_details?.items !== undefined && viewPODetails?.purchase_order_details?.items.length !== 0 && <div className='mt-[30px] w-[95%] mx-auto'>
                            <a className=' font-semibold text-xl ml-[7px]'>Items</a>
                            <ItemsTable ItemsList={viewPODetails?.purchase_order_details?.items}/>
                        </div>}
                        {/* GRN list */}
                        {viewPODetails?.grn_entries !== undefined && viewPODetails?.grn_entries.length !== 0 && <div data-testid="grn-table" className='mt-[30px] w-[95%] mx-auto'>
                            <a className=' font-semibold text-xl ml-[7px]'>GRN Entries</a>
                            <GRNTable GRNList={viewPODetails?.grn_entries}/>
                        </div>}
                    </div>}
            </Suspense>
        </CardHeader>
    )
}

export default ViewPurchaseOrder;